import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';

/**
 * Admin-only route guard. Layers on top of ProtectedRoute's intent:
 * - loading        → skeleton
 * - not signed in  → /login (with redirect back)
 * - signed in, not admin → /library (UX gate; real enforcement is the
 *   backend require_admin dependency — this just avoids dead-end screens)
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="container">
        <div className="skeleton-stack" aria-busy="true" aria-live="polite">
          <div className="skeleton skeleton-title" />
          <div className="skeleton skeleton-line" />
          <div className="skeleton skeleton-block" />
        </div>
      </main>
    );
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  if (!isAdmin) {
    return <Navigate to="/library" replace />;
  }
  return <>{children}</>;
}
